// firebase
import { doc, collection, setDoc, getDoc, updateDoc, arrayUnion, arrayRemove, deleteDoc } from "firebase/firestore";
import { db } from "config/firebase";

// utils
import unixTimestampInSeconds from "utils/unixTimestampInSeconds";

// A ---------------------------------------------------------------------- M

export const addAlarmUser = async (userID, tagID) => {
  try {
    const tagDocRef = doc(db, "tagsdata", tagID);
    await updateDoc(tagDocRef, {
      alarmUsers: arrayUnion(userID),
    });
    console.log(`Alarm user added to ${tagID}`);
    return true;
  } catch (error) {
    console.error(`Error in addAlarmUser for uid ${userID} and tag ${tagID}:`, error);
    return false;
  }
};

export const removeAlarmUser = async (userID, tagID) => {
  try {
    const tagDocRef = doc(db, "tagsdata", tagID);
    await updateDoc(tagDocRef, {
      alarmUsers: arrayRemove(userID),
    });
    console.log(`Alarm user removed from ${tagID}`);
    return true;
  } catch (error) {
    console.error(`Error in removeAlarmUser for uid ${userID} and tag ${tagID}:`, error);
    return false;
  }
};

export const createAlarmTrigger = async (databoxID, userID, trigger) => {
  try {
    const triggerRef = doc(collection(db, "tagsdata", databoxID, "triggers"));
    await setDoc(triggerRef, {
      ...trigger,
      createdAt: unixTimestampInSeconds(),
      createdBy: userID,
    });
    console.log("Trigger created successfully!");
  } catch (error) {
    console.error("Error creating trigger:", error);
    throw new Error("Failed to create trigger");
  }
};

export const deleteAlarmTrigger = async (databoxID, triggerID) => {
  try {
    const triggerRef = doc(db, "tagsdata", databoxID, "triggers", triggerID);
    await deleteDoc(triggerRef);
    console.log("Trigger deleted successfully!");
  } catch (error) {
    console.error("Error deleting trigger:", error);
    throw new Error("Failed to delete trigger");
  }
};

export const hasUserAlarmOn = async (userID, tagID) => {
  try {
    const tagDocRef = doc(db, "tagsdata", tagID);
    const tagDocSnapshot = await getDoc(tagDocRef);

    if (!tagDocSnapshot.exists()) {
      return false;
    }

    return tagDocSnapshot.data()?.alarmUsers?.includes(userID) || false;
  } catch (error) {
    console.error(`Error in hasUserAlarmOn for uid ${userID} and tag ${tagID}:`, error);
    return false;
  }
};
